
import React from 'react';
import { useUser } from '@/context/UserContext';
import { Button } from '@/components/ui/button';
import { Shield, ShieldAlert } from 'lucide-react';

const AdminStatusToggle: React.FC = () => {
  const { user, setAdminStatus } = useUser();
  
  if (!user) return null;
  
  const toggleAdminStatus = () => {
    setAdminStatus(!user.isAdmin);
  };
  
  return (
    <div className="p-4 bg-white shadow rounded-lg border border-dashed border-gray-300 mb-6">
      <div className="flex flex-col sm:flex-row items-center justify-between">
        <div className="flex items-center space-x-3 mb-3 sm:mb-0">
          {user.isAdmin ? (
            <Shield className="h-6 w-6 text-green-500" />
          ) : (
            <ShieldAlert className="h-6 w-6 text-gray-400" />
          )}
          <div>
            <h3 className="font-medium">Admin Status</h3>
            <p className="text-sm text-gray-500">
              {user.isAdmin 
                ? 'You currently have admin privileges' 
                : 'You do not have admin privileges'}
            </p>
          </div>
        </div>
        <Button 
          variant={user.isAdmin ? "destructive" : "default"}
          onClick={toggleAdminStatus}
          className="whitespace-nowrap"
        >
          {user.isAdmin ? 'Revoke Admin Status' : 'Grant Admin Status'}
        </Button>
      </div>
      <p className="text-xs text-gray-400 mt-2">
        Note: This toggle is only available in development mode. In production, admin status would be managed through the backend.
      </p>
    </div>
  );
};

export default AdminStatusToggle;
